import { v4 as uuidv4 } from 'uuid';
import { format, isToday, isTomorrow, isThisWeek, parseISO, startOfDay, addDays, isBefore, isSameDay } from 'date-fns';
import * as chrono from 'chrono-node';

export const generateId = () => uuidv4();

export const parseNaturalLanguageDate = (text) => {
  const results = chrono.parse(text);
  if (results.length > 0) {
    const parsed = results[0];
    const cleanedText = text.replace(parsed.text, '').trim();
    return {
      title: cleanedText || text,
      dueDate: parsed.start.date().toISOString(),
      dueTime: parsed.start.isCertain('hour')
        ? format(parsed.start.date(), 'HH:mm')
        : null,
      originalParsed: parsed.text,
    };
  }
  return { title: text, dueDate: null, dueTime: null };
};

export const formatDueDate = (dateStr) => {
  if (!dateStr) return null;
  const date = typeof dateStr === 'string' ? parseISO(dateStr) : dateStr;
  if (isToday(date)) return 'Today';
  if (isTomorrow(date)) return 'Tomorrow';
  if (isThisWeek(date)) return format(date, 'EEEE');
  return format(date, 'MMM d');
};

export const isOverdue = (dateStr) => {
  if (!dateStr) return false;
  const date = typeof dateStr === 'string' ? parseISO(dateStr) : dateStr;
  return isBefore(startOfDay(date), startOfDay(new Date()));
};

export const getSmartDefaults = (currentView, currentProject) => {
  const now = new Date();
  const hour = now.getHours();

  let status = 'inbox';
  if (currentView && currentView !== 'logbook') {
    status = currentView;
  }

  let dueDate = null;
  if (status === 'today') {
    dueDate = new Date().toISOString();
  } else if (hour >= 18 && status === 'inbox') {
    // After 6pm, suggest tomorrow
  }

  return {
    status,
    dueDate,
    projectId: currentProject || null,
  };
};

export const groupTasksByDate = (tasks) => {
  const groups = {};
  const today = startOfDay(new Date());

  tasks.forEach((task) => {
    if (!task.dueDate) {
      const key = 'No Date';
      if (!groups[key]) groups[key] = [];
      groups[key].push(task);
      return;
    }
    const date = startOfDay(parseISO(task.dueDate));
    let key;
    if (isSameDay(date, today)) {
      key = 'Today';
    } else if (isSameDay(date, addDays(today, 1))) {
      key = 'Tomorrow';
    } else {
      key = format(date, 'EEEE, MMMM d');
    }
    if (!groups[key]) groups[key] = [];
    groups[key].push(task);
  });

  return groups;
};

export const VIEW_CONFIG = {
  inbox: { label: 'Inbox', icon: 'Inbox', color: '#6B8CA8' },
  today: { label: 'Today', icon: 'Star', color: '#F5A623' },
  upcoming: { label: 'Upcoming', icon: 'Calendar', color: '#C0764A' },
  anytime: { label: 'Anytime', icon: 'Layers', color: '#7B68EE' },
  someday: { label: 'Someday', icon: 'Cloud', color: '#B8E986' },
  logbook: { label: 'Logbook', icon: 'BookOpen', color: '#8B572A' },
};
